// extracted by mini-css-extract-plugin
module.exports = {"root":"_3JZcL","bg":"UF5hB","i":"_1tAPU","b":"_1lLhK","l":"_2IZqH","r":"_1wE0O"};